import React from 'react';
import { Divider, Icon, Header, Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Modal from 'PointOfSale/modules/common/component/Modal';
import POSButton from 'PointOfSale/modules/common/component/Button';
import TabMenus from 'PointOfSale/modules/common/component/TabMenus';
import ScrollContainer from 'PointOfSale/modules/common/container/ScrollContainer';
import FoodItemsList from 'PointOfSale/modules/mealTypes/container/FoodItemsList';

const EditFoodItemComponent = props => {
  const {
    open,
    onClose,
    tabMenus,
    tabClickHandler,
    searchText,
    searchHandler,
    allItemsSelected,
    noItemsSelected,
    toggleSelectedItems,
    save,
  } = props;

  return (
    <Modal
      id="edit-selected-food-item-modal"
      unMountOnClose={true}
      key="sessionModal"
      open={open}
      size={'large'}
      onClose={onClose}
      actions={
        <div className="close-button">
          <POSButton label="Close" clickHandler={onClose} selected />
        </div>
      }
      actionClassName="modal-action"
      closeOnDimmerClick={false}
    >
      <Segment className="flex-1 flex flex-col flex-no-wrap">
        <Header as="h4" className="text-orange">
          Select Items for Serving
        </Header>
        <TabMenus
          pointing
          color="orange"
          tabMenus={tabMenus}
          tabClickHandler={tabClickHandler}
          searchBox
          searchText={searchText}
          searchHandler={searchHandler}
        />
        <ScrollContainer enableScrollButtons height="25">
          <FoodItemsList isInModal />
        </ScrollContainer>
        <Divider horizontal>
          <div>
            <Icon
              className="divider-icon"
              disabled={allItemsSelected}
              onClick={() => toggleSelectedItems(true)}
              link
              circular
              size="large"
              name="chevron circle down"
            />
            <Icon
              className="divider-icon"
              name="save"
              size="large"
              link
              circular
              onClick={save}
            />
            <Icon
              className="divider-icon"
              disabled={noItemsSelected}
              flipped={'vertically'}
              onClick={() => toggleSelectedItems(false)}
              link
              circular
              size="large"
              name="chevron circle down"
            />
          </div>
        </Divider>
        <ScrollContainer enableScrollButtons height="25">
          <FoodItemsList
            isSelectedFoodItemsBucket
            isFlat
            isInModal
            modalId="edit-selected-food-item-modal"
          />
        </ScrollContainer>
      </Segment>
    </Modal>
  );
};
EditFoodItemComponent.propTypes = {
  onClose: PropTypes.func,
  header: PropTypes.func,
  actions: PropTypes.array,
  actionClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  headerClassName: PropTypes.string,
};
export default EditFoodItemComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/component/EditSelectedFoodItems.js